<!--
 * @Author: ken yang
 * @Date: 2025-04-25 17:00:34
 * @LastEditTime: 2025-04-29 18:26:44
 * @LastEditors: ken yang
 * @Description: 活动弹窗入口
 * @FilePath: /uexch_pc/src/components/common/EntryDiaManage.vue
-->
<template>
  <div>
    <component
      :is="activeDialog.component"
      v-if="activeDialog"
      :key="activeDialog.key"
      @end="onDialogEnd(activeDialog.key)"
    />
  </div>
</template>
<script setup>
import { getBusinessPath } from '@/utils/localeRoute.js'
import Announcement from './Announcement.vue'
import DiaActivity from './DiaActivity.vue'
import DiaGrowthPopup from './DiaGrowthPopup.vue'
import DiaNewUserActivity from './DiaNewUserActivity.vue'
import IpRestrictTip from './IpRestrictTip.vue'

const route = useRoute()
import { onBeforeMount } from 'vue'

const dialogRegistry = [
  {
    key: 'IpRestrictTip',
    component: IpRestrictTip,
    enabled: true,
    order: 10,
    view: {
      mode: 'exclude',
      paths: ['/login', '/setNewPassword', '/ru', '/user/register', '/help/content']
    }
  },
  {
    key: 'Announcement',
    component: Announcement,
    enabled: true,
    order: 15,
    view: {
      mode: 'exclude',
      paths: ['/ru']
    }
  },
  {
    key: 'DiaGrowthPopup',
    component: DiaGrowthPopup,
    enabled: true,
    order: 30,
    view: {
      mode: 'include',
      paths: ['/home']
    }
  },
  {
    key: 'DiaActivity', // 改弹窗已经弃用
    component: DiaActivity,
    enabled: false,
    order: 35,
    view: {
      mode: 'include',
      paths: ['/home']
    }
  },
  { // 和glenn沟通过该弹窗已弃用
    key: 'DiaNewUserActivity',
    component: DiaNewUserActivity,
    enabled: false,
    order: 50,
    view: {
      mode: 'include',
      paths: ['/home']
    }
  }
]

let dialogQueue = $ref([])
let activeIndex = $ref(0)
const completedDialogKeys = new Set()

const activeDialog = $computed(() => {
  return dialogQueue[activeIndex] || null
})

const matchView = (view, businessPath) => {
  if (!view) return true

  const paths = view.paths.map((path) => getBusinessPath(path))
  const matched = paths.includes(businessPath)
  return view.mode === 'include' ? matched : !matched
}

const createDialogQueue = (businessPath) => {
  return dialogRegistry
    .filter((dialog) => dialog.enabled && matchView(dialog.view, businessPath))
    .sort((a, b) => a.order - b.order)
}

const onDialogEnd = (key) => {
  if (completedDialogKeys.has(key)) return
  completedDialogKeys.add(key)
  activeIndex += 1
}

onBeforeMount(() => {
  dialogQueue = createDialogQueue(getBusinessPath(route.path))
})

</script>
<style lang="scss" scoped>
</style>
